import { render } from "./ThongTinLaiXe.vue?vue&type=template&id=b87b1040&scoped=true"
import script from "./ThongTinLaiXe.vue?vue&type=script&lang=js"
export * from "./ThongTinLaiXe.vue?vue&type=script&lang=js"

import "./ThongTinLaiXe.vue?vue&type=style&index=0&id=b87b1040&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87b1040"]])

export default __exports__